<div class="col-12 p-3">
  <div class="row d-flex justify-content-center items" [ngStyle]="{'color': menu.colorText}">
    <div class="col-12 text-center">
      <h4 class="{{menu.fontHeader}} mb-2" [ngStyle]="{'color': menu.colorText}">{{section.name}}</h4>
    </div>
    <div class="{{menu.fontText}}" *ngFor="let item of section.items; let i = index">
      <div translate="no">
        <ng-container *ngIf="!section.upperCaseName">
          {{ item.name | firstuppercase }} {{ item.price ? (item.price | typeNumber: menu.units): '' }}
          <span>{{' '}} | </span>
        </ng-container>
        <ng-container *ngIf="section.upperCaseName">
          {{ item.name | uppercase }} {{ item.price ? (item.price | typeNumber: menu.units): '' }}
          <span>{{' '}} | </span>
        </ng-container>
      </div>
    </div>
  </div>
</div>